// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pD-Qg","top":"styles_top__pLb95","block":"styles_block__NGdfo","content":"styles_content__e+jbC","preview":"styles_preview__lPxKw"};